import React from "react";
import Slider from "react-slick";
import bg from '../frente2.jpg';
import recepcao from '../recepcao.jpg';
import restaurante from '../restaurante2.jpg';
import pool from '../piscina3.jpg';
import quarto from '../quarto6.jpg';
import quarto2 from '../quarto3.jpg'

import * as Style from './style';

export const Component = ({
    
}) => {
	const settings = {
		className: "center",
		centerMode: true,
		infinite: true,
		centerPadding: "60px",
		slidesToShow: 3,
		speed: 500,
		dots: true,
		adaptiveHeight: true,
	};
	 
	
    return (
        <Slider {...settings}>
          <Style.ContainerImage>
            <img src={bg} />
          </Style.ContainerImage>
          <Style.ContainerImage>
            <img src={quarto} />
          </Style.ContainerImage>
          <Style.ContainerImage>
            <img src={restaurante} />
          </Style.ContainerImage>
          <Style.ContainerImage>
            <img src={recepcao}/>
          </Style.ContainerImage>
          <Style.ContainerImage>
            <img src={quarto2} />
          </Style.ContainerImage>
          <Style.ContainerImage>
            <img src={pool} />
          </Style.ContainerImage>
        </Slider>
    );
  };

  export default Component;
